var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.12504 17.4166H11.875C15.8334 17.4166 17.4167 15.8333 17.4167 11.875V7.12498C17.4167 3.16665 15.8334 1.58331 11.875 1.58331H7.12504C3.16671 1.58331 1.58337 3.16665 1.58337 7.12498V11.875C1.58337 15.8333 3.16671 17.4166 7.12504 17.4166Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.fcf6a87bfa5e2bc76ff21684c5a7c404.svg";
export { ForwardRef as ReactComponent };